import 'animate.css';

import { Grid } from '@mui/material';
import { RoutalPalette, VSpacer } from '@nx-smartmonkey/ui';
import { WhatsAppBusinessIcon } from '../../../assets/svg/WhatsAppBusinessIcon';
import { FacebookLogin } from '../../../components/FacebookLogin';
import { useRetrieveOrganization } from '../../../hooks/organization/useRetrieveOrganization';

export const RegisterWhatsapp = () => {
  const { data: organization } = useRetrieveOrganization();

  if (!organization) return null;

  return (
    <Grid
      item
      container
      justifyContent="center"
      flexWrap="nowrap"
      flexDirection="column"
      alignItems="center"
      height="100%"
      width="100%"
      style={{
        backgroundColor: RoutalPalette.neutral00,
      }}
    >
      <Grid maxWidth="500px" width="100%" padding="30px" container flexDirection="column" alignItems="center">
        <WhatsAppBusinessIcon altColor={RoutalPalette.neutral00} style={{ height: `100px`, width: `100px` }} />
        <VSpacer large />
        <FacebookLogin organization={organization} />
      </Grid>
    </Grid>
  );
};
